/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_Step3_DescInputs */

const en_directory_submit_flow_step3_desc = /** @type {(inputs: Directory_Submit_Flow_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill manually or let AI write it`)
};

const zh_directory_submit_flow_step3_desc = /** @type {(inputs: Directory_Submit_Flow_Step3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动填写或让 AI 代写`)
};

/**
* | output |
* | --- |
* | "Fill manually or let AI write it" |
*
* @param {Directory_Submit_Flow_Step3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_step3_desc = /** @type {((inputs?: Directory_Submit_Flow_Step3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_Step3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_step3_desc(inputs)
	return zh_directory_submit_flow_step3_desc(inputs)
});
export { directory_submit_flow_step3_desc as "directory.submit.flow.step3_desc" }